// extracted by mini-css-extract-plugin
export default {"notfound_page":"notfound_notfound_page__dviQ0","container":"notfound_container__EYmH7","notFound":"notfound_notFound__7Tzzx","notFoundBtn":"notfound_notFoundBtn__0qTMS"};